module.exports = __webpack_public_path__ + "img/ContactChat.4c89ff58.svg";